import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import {
  Field,
  MoneyInput,
  SelectField,
  Textarea,
} from '@/components/ui/controls'
import { createProduct } from '../../services/product'
import { getCurrencies, type CurrencyOption } from '../../services/config'

export default function ProductCreate() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [currencyOptions, setCurrencyOptions] = useState<CurrencyOption[]>([])
  const [name, setName] = useState(''),
    [description, setDescription] = useState(''),
    [price, setPrice] = useState(''),
    [currency, setCurrency] = useState('USD')
  useEffect(() => {
    getCurrencies()
      .then((res) => {
        setCurrencyOptions(res.data.currencies)
        setCurrency(res.data.defaultCurrency || 'USD')
      })
      .catch(() =>
        setCurrencyOptions(
          ['USD', 'CNY', 'HKD'].map((code) => ({ code, label: code })),
        ),
      )
  }, [])
  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (!name.trim()) {
      toast.warning('請輸入產品名稱')
      return
    }
    if (!/^\d+(\.\d{1,2})?$/.test(price) || Number(price) < 0.01) {
      toast.warning('請輸入至少 0.01 的價格，最多兩位小數')
      return
    }
    setLoading(true)
    try {
      await createProduct({
        name,
        description,
        price,
        currency,
        productType: 'ONE_TIME',
      })
      toast.success('產品創建成功')
      navigate('/dashboard/products')
    } catch (error) {
      toast.error(error instanceof Error ? error.message : '創建失敗')
    } finally {
      setLoading(false)
    }
  }
  return (
    <div>
      <h2 className="mb-6 text-xl font-semibold">創建產品</h2>
      <Card className="max-w-xl">
        <form onSubmit={submit} className="space-y-5 px-5">
          <Field label="產品名稱" htmlFor="product-name" required>
            <Input
              id="product-name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="例如：Pro 服務"
            />
          </Field>
          <Field label="產品描述" htmlFor="product-description">
            <Textarea
              id="product-description"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="產品描述（可選）"
            />
          </Field>
          <Field label="價格" htmlFor="product-price" required>
            <div className="flex gap-2">
              <MoneyInput
                id="product-price"
                required
                min="0.01"
                step="0.01"
                value={price}
                onValueChange={setPrice}
                placeholder="9.99"
              />
              <SelectField
                id="product-currency"
                aria-label="幣種"
                value={currency}
                onValueChange={setCurrency}
                options={currencyOptions.map((c) => ({
                  value: c.code,
                  label: c.label,
                }))}
              />
            </div>
          </Field>
          <div className="flex gap-2">
            <Button
              type="submit"
              disabled={loading}
              data-testid="product-submit"
            >
              創建產品
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/dashboard/products')}
            >
              取消
            </Button>
          </div>
        </form>
      </Card>
    </div>
  )
}
